/**
 * Coalesce concurrent async work by key (in-flight).
 * Optional ttlMs keeps the settled result briefly so React Strict Mode
 * remounts reuse the same response instead of firing a second network call.
 */
const inflight = new Map();
const recent = new Map();

export function coalesceAsync(key, fn, options = {}) {
  const ttlMs = Number(options?.ttlMs) || 0;

  if (inflight.has(key)) {
    return inflight.get(key);
  }

  if (ttlMs > 0) {
    const hit = recent.get(key);
    if (hit && hit.expiresAt > Date.now()) {
      return Promise.resolve(hit.value);
    }
  }

  const promise = Promise.resolve()
    .then(fn)
    .then((value) => {
      if (ttlMs > 0) {
        recent.set(key, { value, expiresAt: Date.now() + ttlMs });
      }
      return value;
    })
    .finally(() => {
      inflight.delete(key);
    });

  inflight.set(key, promise);
  return promise;
}
